module.exports = __webpack_public_path__ + "img/0S6A9886.5dde0378.jpg";